import { gql } from './graphql';

interface CreateSafetyCheckParams {
  trailer_uuid: string;
  facility_id: string;
  dock_uuid?: string | null;
  yard_spot_uuid?: string | null;
  description?: string;
}

interface SafetyCheckResult {
  uuid: string;
}

const CREATE_SAFETY_CHECK = `
  mutation CreateSafetyCheck(
    $trailer_uuid: String!,
    $facility_id: ID!,
    $dock_uuid: String,
    $yard_spot_uuid: String,
    $description: String
  ) {
    create_safety_check(input: {
      trailer_uuid: $trailer_uuid
      facility_id: $facility_id
      dock_uuid: $dock_uuid
      yard_spot_uuid: $yard_spot_uuid
      description: $description
    }) {
      uuid
    }
  }
`;

export async function createSafetyCheck(params: CreateSafetyCheckParams): Promise<SafetyCheckResult> {
  const data = await gql<{ create_safety_check: SafetyCheckResult }>(CREATE_SAFETY_CHECK, params);
  return data.create_safety_check;
}
